import HttpService from "./htttp.service";

class PaymentsService {
    getList = async(payload) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "payments"
        return await HttpService.get(getListEndPoint, payload, token);
    }
    updateLease = async(payload) => {
        const token = localStorage.getItem("");
        const updateLeaseEndPoint = "leases-v2/" + payload.lease_id;
        return await HttpService.post(updateLeaseEndPoint, payload, token, false);
    }

    markPending = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = "payments/pending";
        return await HttpService.post(endpoint, payload, token, false);
    };

    markApprove = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = "payments/approve";
        return await HttpService.post(endpoint, payload, token, false);
    };

    markCancel = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = "payments/cancel";
        return await HttpService.post(endpoint, payload, token, false);
    };

    fetchPaymentMethods = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = "payment_methods"; // https://mgt.yyproperty.org/backend/api/v1/payment_methods?list=display_name
        return await HttpService.get(endpoint, payload, token);
    };

    newPayment = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = "payments";
        return await HttpService.post(endpoint, payload, token, false);
    };

    getReceiptPDF = async (payload) => {
        const token = localStorage.getItem("token");
        const endpoint = `payments/receipt`;
        return await HttpService.post(endpoint, payload, token, true);
    };

    getReceiptDetails = async (payment_id) => {
        const token = localStorage.getItem("token");
        const endpoint = `payments/${payment_id}`;
        return await HttpService.get(endpoint, {}, token);
    };
}

export default new PaymentsService();
